import { PatientDoc } from "../models/patient-docs.model";

/** True when persisted document metadata is a non-empty object (e.g. saved OCR). */
export function patientDocMetadataNonEmpty(
  metadata: Record<string, unknown> | null | undefined
): boolean {
  if (metadata == null) {
    return false;
  }
  if (typeof metadata !== "object" || Array.isArray(metadata)) {
    return false;
  }
  return Object.keys(metadata).length > 0;
}

export function patientDocHasMetadata(
  doc: PatientDoc | null | undefined
): boolean {
  return patientDocMetadataNonEmpty(doc?.metadata);
}
